import React, { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { useNavigate } from "react-router-dom";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

const NoServiceAppFound = ({ id }: { id: number }): ReactElement => {
 const navigate = useNavigate();

 const handleGoToCreate = () => {
  navigate(`/servers/cluster/${id}/add/appservice`);
 };

 return (
  <Stack spacing={2}>
   <Alert severity="warning">
    <Typography variant="subtitle2">
     <FormattedMessage id="cluster.noServiceAppFound" />
    </Typography>
   </Alert>
   <Stack direction="row" justifyContent="flex-end" alignItems="center">
    <Button onClick={handleGoToCreate}>
     <FormattedMessage id="cluster.createAppService" />
    </Button>
   </Stack>
  </Stack>
 );
};

export default NoServiceAppFound;
